var _defs, _path, _path2, _path3, _path4, _rect, _g, _rect2, _g2, _rect3, _g3, _rect4, _path5;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconHolidayPropertyRools(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 31.55 45.39",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:url(#linear-gradient);}.cls-2{fill:url(#linear-gradient-2);}.cls-3{fill:url(#linear-gradient-3);}.cls-14,.cls-4{fill:none;}.cls-4{stroke-miterlimit:10;stroke:url(#linear-gradient-4);}.cls-5{fill:url(#linear-gradient-5);}.cls-6,.cls-7{fill-rule:evenodd;}.cls-6{fill:url(#linear-gradient-6);}.cls-7{fill:url(#linear-gradient-7);}.cls-8{clip-path:url(#clip-path);}.cls-9{fill:url(#linear-gradient-9);}.cls-10{clip-path:url(#clip-path-2);}.cls-11{fill:url(#linear-gradient-11);}.cls-12{clip-path:url(#clip-path-3);}.cls-13{fill:url(#linear-gradient-13);}.cls-15{fill:url(#linear-gradient-14);}"), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 19.08,
    y1: 25.66,
    x2: 33.8,
    y2: 25.66,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9b4d9d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e25e68"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 19.08,
    y1: 33.51,
    x2: 33.8,
    y2: 33.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 19.08,
    y1: 40.77,
    x2: 33.8,
    y2: 40.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 9.22,
    y1: 24.2,
    x2: 40.78,
    y2: 24.2,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-5",
    x1: 18.61,
    y1: 11.5,
    x2: 31.39,
    y2: 11.5,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-6",
    x1: 12.59,
    y1: 26.06,
    x2: 16.4,
    y2: 26.06,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-7",
    x1: 12.65,
    y1: 33.42,
    x2: 16.47,
    y2: 33.42,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path",
    transform: "translate(-9.22 -1.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 19.08,
    y: 25.23,
    width: 14.72,
    height: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-9",
    x1: 19.11,
    y1: 25.66,
    x2: 33.8,
    y2: 25.66,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2",
    transform: "translate(-9.22 -1.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 19.08,
    y: 33.07,
    width: 14.72,
    height: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-11",
    x1: 19.11,
    y1: 33.51,
    x2: 33.8,
    y2: 33.51,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3",
    transform: "translate(-9.22 -1.5)"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 19.08,
    y: 40.33,
    width: 14.72,
    height: 0.87
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-13",
    x1: 19.11,
    y1: 40.77,
    x2: 33.8,
    y2: 40.77,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-14",
    x1: 12.65,
    y1: 40.02,
    x2: 17.31,
    y2: 40.02,
    xlinkHref: "#linear-gradient"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M38,5.26H28.26a3.26,3.26,0,0,0-6.52,0H12A2.28,2.28,0,0,0,9.72,7.54V44.12A2.28,2.28,0,0,0,12,46.39H38a2.28,2.28,0,0,0,2.28-2.27V7.54A2.28,2.28,0,0,0,38,5.26Z",
    transform: "translate(-9.22 -1.5)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M31.2,11.06,25.73,5.27a1,1,0,0,0-.15-.14L25.4,5,25.2,5,25,5l-.21,0L24.6,5l-.18.1a1.07,1.07,0,0,0-.16.14l-5.46,5.8a.46.46,0,0,0-.07.07l-.05.09,0,.09s0,.06,0,.1a.28.28,0,0,0,0,.09v.1s0,.07,0,.1l0,.09.05.09.06.08a.23.23,0,0,0,.07.07.46.46,0,0,0,.07.07l.09,0,.09,0,.1,0h.37v4.91a.44.44,0,0,0,0,.1.29.29,0,0,0,0,.09l0,.1.05.09a.22.22,0,0,0,.05.08l.06.09a.46.46,0,0,0,.07.07.46.46,0,0,0,.07.07l.08.06.09.05.09,0,.09,0,.1,0H29.6l.09,0,.1,0,.09,0,.09-.05.08-.06.07-.07a.27.27,0,0,0,.07-.08l.06-.08a.56.56,0,0,0,.05-.08.36.36,0,0,0,0-.09.42.42,0,0,0,0-.1.29.29,0,0,0,0-.09s0-.07,0-.1V12.22h.39l.09,0,.1,0,.08,0a.27.27,0,0,0,.08-.07.23.23,0,0,0,.07-.07l.06-.08.05-.09,0-.09s0-.06,0-.1v-.1a.38.38,0,0,0,0-.1s0-.06,0-.09a.36.36,0,0,1,0-.09.41.41,0,0,1-.05-.09l-.07-.08Zm-7.89,6.38V12.57a.09.09,0,0,1,0-.05.06.06,0,0,1,0,0l0-.05,0,0,0,0,0,0h3.07l0,0,0,0,0,0,0,.05a.06.06,0,0,1,0,0,.09.09,0,0,1,0,.05v4.87Zm7.4-5.83h-.64l-.06,0-.05,0-.05,0,0,0a.14.14,0,0,0,0,.06.08.08,0,0,0,0,.05.11.11,0,0,0,0,.06v5.2l0,.08a.16.16,0,0,1,0,.07.18.18,0,0,1-.05.07l-.06.05-.08,0-.07,0H27.3V12.57a.28.28,0,0,0,0-.09.25.25,0,0,0,0-.08s0-.05,0-.08l0-.08,0-.07-.05-.08,0-.06L27.05,12,27,11.91l-.06-.05-.08,0-.07,0-.08,0-.08,0H23.39l-.08,0-.08,0-.08,0-.07,0-.07.05L23,12a.18.18,0,0,0-.05.07l0,.06-.05.08,0,.07,0,.08a.24.24,0,0,0,0,.08.25.25,0,0,0,0,.08.28.28,0,0,0,0,.09v4.87H20.5l-.08,0-.07,0-.06-.05a.18.18,0,0,1-.05-.07.16.16,0,0,1,0-.07l0-.08s0-.05,0-.08V11.9a.35.35,0,0,0,0-.06s0,0,0-.05,0,0,0-.06l0,0-.05,0-.05,0h-.7l0,0,0,0a0,0,0,0,1,0-.05,0,0,0,0,1,0,0L24.7,5.71l.07,0,.07,0,.08,0h.16l.08,0,.07,0s.05,0,.06,0l5.47,5.76,0,0a0,0,0,0,1,0,0v0l0,0h0Z",
    transform: "translate(-9.22 -1.5)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-6",
    d: "M15,26.06l1.36-1.37a.31.31,0,0,0,0-.45.33.33,0,0,0-.45,0L14.5,25.6l-1.37-1.36a.33.33,0,0,0-.45,0,.31.31,0,0,0,0,.45L14,26.06l-1.36,1.36a.32.32,0,1,0,.45.45l1.37-1.36,1.36,1.36a.32.32,0,1,0,.45-.45Z",
    transform: "translate(-9.22 -1.5)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M15,33.42l1.36-1.36a.32.32,0,0,0-.45-.45L14.56,33,13.2,31.61a.32.32,0,0,0-.46,0,.33.33,0,0,0,0,.45l1.36,1.36-1.36,1.36a.33.33,0,1,0,.46.46l1.36-1.36,1.36,1.36a.33.33,0,0,0,.45,0,.32.32,0,0,0,0-.46Z",
    transform: "translate(-9.22 -1.5)"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 9.86,
    y: 23.73,
    width: 14.72,
    height: 0.87
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-8"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M33.31,26.1H19.5l-.09,0-.08,0L19.25,26l-.06-.06,0-.08a.13.13,0,0,1,0-.08.28.28,0,0,1,0-.09.25.25,0,0,1,0-.08.11.11,0,0,1,0-.08l0-.08.06-.06.08-.06.08,0,.09,0H33.41l.09,0,.08,0,.08.06.06.06a.3.3,0,0,1,0,.08.11.11,0,0,1,0,.08.25.25,0,0,1,0,.08.28.28,0,0,1,0,.09.13.13,0,0,1,0,.08.3.3,0,0,1,0,.08l-.06.06-.08.06-.08,0-.09,0Z",
    transform: "translate(-9.22 -1.5)"
  }))), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-2",
    x: 9.86,
    y: 31.57,
    width: 14.72,
    height: 0.87
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    className: "cls-10"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-11",
    d: "M33.31,33.94H19.5l-.09,0-.08,0-.08-.06-.06-.06,0-.08a.11.11,0,0,1,0-.08.25.25,0,0,1,0-.08.28.28,0,0,1,0-.09.13.13,0,0,1,0-.08l0-.08.06-.06.08-.06.08,0,.09,0H33.41l.09,0,.08,0,.08.06.06.06a.3.3,0,0,1,0,.08.13.13,0,0,1,0,.08.28.28,0,0,1,0,.09.25.25,0,0,1,0,.08.11.11,0,0,1,0,.08.3.3,0,0,1,0,.08l-.06.06-.08.06-.08,0-.09,0Z",
    transform: "translate(-9.22 -1.5)"
  }))), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    x: 9.86,
    y: 38.83,
    width: 14.72,
    height: 0.87
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    className: "cls-12"
  }, /*#__PURE__*/React.createElement("path", {
    className: "cls-13",
    d: "M33.31,41.2H19.5l-.09,0-.08,0-.08-.06L19.19,41l0-.08a.11.11,0,0,1,0-.08.25.25,0,0,1,0-.08.28.28,0,0,1,0-.09.13.13,0,0,1,0-.08.3.3,0,0,1,0-.08l.06-.06.08-.06.08,0,.09,0H33.41l.09,0,.08,0,.08.06.06.06a.3.3,0,0,1,0,.08.13.13,0,0,1,0,.08.28.28,0,0,1,0,.09.25.25,0,0,1,0,.08.11.11,0,0,1,0,.08.3.3,0,0,1,0,.08l-.06.06-.08.06-.08,0-.09,0Z",
    transform: "translate(-9.22 -1.5)"
  }))), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    className: "cls-14",
    x: 3.42,
    y: 36.57,
    width: 4.67,
    height: 3.9
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-15",
    d: "M17.28,38.22l-2.9,3.42L14.1,42l-.32-.29-1-.88a.38.38,0,0,1,0-.53.38.38,0,0,1,.5-.07l.79.54,3.13-2.65a.09.09,0,0,1,.12.13",
    transform: "translate(-9.22 -1.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHolidayPropertyRools);
export default __webpack_public_path__ + "static/media/icon-holiday-property-rools.aca401af91cd6cca588b7616f354345a.svg";
export { ForwardRef as ReactComponent };